<template>
  <v-container fluid class="dashboard-rh-view ui-module-fade-in-up">
    <v-card class="ui-module-card ui-module-fade-in-up dashboard-shell" flat>
      <v-card-text class="dashboard-content">
        <v-row class="toolbar-row" justify="end" align="center">
          <v-col cols="auto" class="d-flex align-center justify-end toolbar-filter-col">
            <v-autocomplete
              class="filter-input"
              v-model="filtroPuesto"
              :items="puestos"
              item-value="catPuesto.puesto"
              item-text="catPuesto.puesto"
              color="secondary"
              background-color="primary"
              rounded
              filled
              hide-details
              placeholder="Filtrar por puesto..."
              clearable
            />
          </v-col>
          <v-col cols="auto" class="d-flex align-center justify-end toolbar-filter-col">
            <v-text-field
              class="filter-input"
              v-model="filtroNombre"
              color="secondary"
              background-color="primary"
              rounded
              filled
              hide-details
              placeholder="Buscar por nombre..."
              append-icon="mdi-magnify"
              clearable
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="filteredPersonal"
              :loading="loading"
              loading-text="Cargando personal..."
              no-data-text="Sin registros"
              class="ui-module-card ui-module-table tabla-personal"
              color="primary"
              :footer-props="{ 'items-per-page-text': 'Filas por página' }"
            >
              <template v-slot:[`item.nombreCompleto`]="{ item }">
                <span class="nombre-text">{{ getNombreCompleto(item) }}</span>
              </template>

              <template v-slot:[`item.CUIP`]="{ item }">
                <span class="cuip-text">{{ item.CUIP || '—' }}</span>
              </template>

              <template v-slot:[`item.puesto`]="{ item }">
                <span class="puesto-text">{{ item.puesto || '—' }}</span>
              </template>

              <template v-slot:[`item.acciones`]="{ item }">
                <div class="acciones-wrapper">
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          name: 'recursos_humanos.registro_falta_administrativa',
                          params: { id: item.idPersonal },
                          query: { from: 'dashboardRH' },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-book-alert</v-icon></v-btn
                      >
                    </template>
                    <span>Registrar trámite administrativo</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CAMBIO_DE_ESTATUS)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          name: 'actualizaEstatus',
                          params: { id: item.idPersonal },
                          query: { from: 'dashboardRH' },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-police-badge</v-icon></v-btn
                      >
                    </template>
                    <span>Cambiar de estatus</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          name: 'asignacionTurno',
                          params: { id: item.idPersonal },
                          query: { from: 'dashboardRH' },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-timetable</v-icon></v-btn
                      >
                    </template>
                    <span>Asignación de turno</span>
                  </v-tooltip>

                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_PUESTO_FUNCION_ADSCRIPCION)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          name: 'asignaSedePersonal',
                          params: { id: item.idPersonal },
                          query: { from: 'dashboardRH' },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-office-building-marker</v-icon></v-btn
                      >
                    </template>
                    <span>Asignación de puesto, función y adscripción</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          path: '/recursos_humanos/expediente_personal/' + item.idPersonal,
                          params: { id: item.idPersonal },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-account</v-icon></v-btn
                      >
                    </template>
                    <span>Ver expediente</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="action-btn" @click="generarConstanciaNoAdeudo(item)" icon v-on="on" v-bind="attrs"
                        ><v-icon>mdi-file-word</v-icon></v-btn
                      >
                    </template>
                    <span>Constancia de No Adeudo</span>
                  </v-tooltip>

                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.VER_ASISTENCIAS)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="action-btn"
                        :to="{
                          name: 'recursos_humanos.asistencias',
                          params: { id: item.idPersonal },
                          query: { from: 'dashboardRH' },
                        }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-clipboard-check-outline</v-icon></v-btn
                      >
                    </template>
                    <span>Asistencias</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped>
.dashboard-shell {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.dashboard-content {
  padding: 20px !important;
}

.toolbar-row {
  margin-bottom: 4px;
}

.toolbar-filter-col {
  width: 360px;
  max-width: 360px;
  flex: 0 0 360px;
}

::v-deep .toolbar-filter-col .v-input {
  width: 100%;
  margin-top: 0 !important;
}

::v-deep .filter-input .v-input__slot {
  background: rgba(8, 14, 19, 0.52) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .filter-input .v-label,
::v-deep .filter-input input,
::v-deep .filter-input .v-icon,
::v-deep .filter-input .v-select__selection {
  color: #e0f0ff !important;
}

::v-deep .filter-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.16) !important;
}

/* Acciones */
.acciones-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

::v-deep .action-btn {
  background: linear-gradient(135deg, #1a262e 0%, #0f1a1f 100%) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.35) !important;
  border-radius: 10px !important;
  transition: all 0.25s ease !important;
}

::v-deep .action-btn .v-icon {
  color: var(--v-secondary-base) !important;
  font-size: 18px !important;
  transition: all 0.25s ease;
}

::v-deep .action-btn:hover {
  background: linear-gradient(135deg, #0f1a1f 0%, #050a0f 100%) !important;
  border-color: var(--v-secondary-base) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
}

::v-deep .action-btn:hover .v-icon {
  color: #ffffff !important;
  transform: scale(1.15);
}

@media (max-width: 960px) {
  .toolbar-filter-col {
    width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }
}
</style>

<script>
import { Packer } from 'docx'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import BaseInput from '@/components/base/BaseInput.vue'
import ConstanciaNoAdeudo from '@/utils/doc-generator/recursos-humanos/ConstanciaNoAdeudo.js'

export default {
  components: {
    BaseInput,
  },

  async mounted() {
    if (this.personal.length === 0) {
      this.loading = true
      await this.fetchPersonalByDependencia(1)
      this.loading = false
    }

    if (this.puestos.length === 0) {
      await this.fetchPuestos()
    }
  },

  data() {
    return {
      loading: false,
      filtroNombre: '',
      filtroPuesto: null,
      headers: [
        { text: 'Nombre', value: 'nombreCompleto', sortable: true },
        { text: 'CUIP', value: 'CUIP', sortable: false },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Opciones', value: 'acciones', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      personal: 'getFullPersonal',
    }),

    ...mapGetters('puesto', {
      puestos: 'getPuestos',
    }),

    filteredPersonal() {
      return this.personal.filter((p) => {
        const nombreMatch =
          !this.filtroNombre || this.getNombreCompleto(p).toLowerCase().includes(this.filtroNombre.toLowerCase())
        const puestoMatch = !this.filtroPuesto || p.puesto === this.filtroPuesto
        return nombreMatch && puestoMatch
      })
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('personal', ['fetchPersonalByDependencia']),
    ...mapActions('puesto', ['fetchPuestos']),

    getNombreCompleto(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },

    async generarConstanciaNoAdeudo(personal) {
      const fechaHoy = moment().format('YYYY-MM-DD')
      const nombreCompleto = this.getNombreCompleto(personal)
      const area = personal.CatArea && personal.CatArea.nombre ? personal.CatArea.nombre : ''
      const doc = new ConstanciaNoAdeudo({
        nombre: nombreCompleto,
        rfc: personal.rfc || '',
        fecha: fechaHoy,
        area,
        fechaIngreso: personal.fechaIngresoEdoFza || '',
        fechaBaja: personal.fechaBaja || fechaHoy,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ConstanciaNoAdeudo_${nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
